// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2fmpO","content":"styles_content__ubxu-","checkbox":"styles_checkbox__1scL5","checkboxLabel":"styles_checkboxLabel__30Oxb"};